import { useAuth0 } from '@auth0/auth0-react';

import { useGetContentCategories } from 'src/sections/agency/hooks/useGetContentCategories';

const ROLE_CLAIM = 'https://miami-ship/roles';
const ALLOWED_ROLES = ['owner', 'employee'];

/**
 * Component to prefetch and cache Content Categories on app load.
 * Only runs for roles that actually use content categories (owner/employee);
 * the endpoint returns 403 for distribution-client/receptor users.
 */
export default function PrefetchContentCategories() {
  const { user } = useAuth0();
  const roles: string[] = user?.[ROLE_CLAIM]?.split(' ') ?? [];
  const enabled = roles.some((r) => ALLOWED_ROLES.includes(r));

  useGetContentCategories({ enabled });

  return null;
}
